import {
  ADD_STAFF_FAILURE,
  ADD_STAFF_REQUEST,
  ADD_STAFF_SUCCESS,
  DELETE_STAFF_FAILURE,
  DELETE_STAFF_REQUEST,
  DELETE_STAFF_SUCCESS,
  FETCH_LIST_STAFF_FAILURE,
  FETCH_LIST_STAFF_REQUEST,
  FETCH_LIST_STAFF_SUCCESS,
  FETCH_STAFF_FAILURE,
  FETCH_STAFF_REQUEST,
  FETCH_STAFF_SUCCESS,
  HISTORY_STAFF_FAILURE,
  HISTORY_STAFF_REQUEST,
  HISTORY_STAFF_SUCCESS,
  RESET_CURRENT_STAFF,
  UPDATE_STAFF_FAILURE,
  UPDATE_STAFF_REQUEST,
  UPDATE_STAFF_SUCCESS,
} from "./staffType";

export const fetchStaff = (pageNo) => ({
  type: FETCH_LIST_STAFF_REQUEST,
  payload: pageNo,
});

export const fetchStaffSuccess = (staff) => {

  return {
    type: FETCH_LIST_STAFF_SUCCESS,
    payload: { staff },
  };
};

export const fetchStaffFailure = (error) => ({
  type: FETCH_LIST_STAFF_FAILURE,
  payload: { error },
});

export const fetchHistoryStaff = (id) => ({
  type: HISTORY_STAFF_REQUEST,
  payload: id,
});

export const fetchHistoryStaffSuccess = (staff) => ({
  type: HISTORY_STAFF_SUCCESS,
  payload: { staff },
});

export const fetchHistoryStaffFailure = (error) => ({
  type: HISTORY_STAFF_FAILURE,
  payload: { error },
});

// View single staff
export const fetchStaffMember = (staffId) => ({
  type: FETCH_STAFF_REQUEST,
  payload: { staffId },
});

export const fetchStaffMemberSuccess = (staff) => ({
  type: FETCH_STAFF_SUCCESS,
  payload: { staff },
});

export const fetchStaffMemberFailure = (error) => ({
  type: FETCH_STAFF_FAILURE,
  payload: { error },
});

// Add staff
export const addStaff = (staffData) => {

  return {
      type: ADD_STAFF_REQUEST,
      payload:  staffData ,
  };
};

export const addStaffSuccess = (staff) => {
  
  return {
      type: ADD_STAFF_SUCCESS,
      payload: { staff },
  };
};

export const addStaffFailure = (error) => {

  return {
      type: ADD_STAFF_FAILURE,
      payload: { error },
  };
};

// Edit staff
export const updateStaff = (staffId, staffData) => {

  return {
    type: UPDATE_STAFF_REQUEST,
    payload: { staffId, staffData },
  };
};

export const updateStaffSuccess = (staff) => ({
  type: UPDATE_STAFF_SUCCESS,
  payload: { staff },
});

export const updateStaffFailure = (error) => ({
  type: UPDATE_STAFF_FAILURE,
  payload: { error },
});

// Delete staff
export const deleteStaff = (staffId) => ({
  type: DELETE_STAFF_REQUEST,
  payload: { staffId },
});

export const deleteStaffSuccess = (staffId) => ({
  type: DELETE_STAFF_SUCCESS,
  payload: { staffId },
});

export const deleteStaffFailure = (error) => ({
  type: DELETE_STAFF_FAILURE,
  payload: { error },
});

// Reset current staff
export const resetCurrentStaff = () => ({
  type: RESET_CURRENT_STAFF,
});